export class AdministrationStats {
  workspacesCount: number;
  totalUsersCount: number;
}
